import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Star } from 'lucide-react';
import { MemberProductInterest } from '@/types/member-product-interests';

interface ProductInterestBadgeProps {
  interest: MemberProductInterest;
  showLevel?: boolean;
}

export const ProductInterestBadge: React.FC<ProductInterestBadgeProps> = ({ 
  interest, 
  showLevel = false 
}) => {
  const getInterestColor = (level: number) => {
    switch (level) {
      case 5: return 'bg-primary text-primary-foreground';
      case 4: return 'bg-primary/80 text-primary-foreground';
      case 3: return 'bg-secondary text-secondary-foreground';
      case 2: return 'bg-muted text-muted-foreground';
      case 1: return 'bg-muted/50 text-muted-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <Badge 
      variant="secondary" 
      className={`text-xs px-2 py-1 ${getInterestColor(interest.interest_level)}`}
    >
      {interest.perk?.title}
      {showLevel && (
        <div className="ml-1 flex items-center">
          <Star className="w-3 h-3 fill-current" />
          <span className="ml-0.5 text-xs">{interest.interest_level}</span>
        </div>
      )}
    </Badge>
  );
};